import {
  PaymentSystemListItem,
  PaymentSystemListPayload,
} from '@/models/dictionary/payment-system-list.model';
import { api } from '@/services/http.service';
import { showErrorNotification } from '@/utils/show-notification.util';
import { defineStore } from 'pinia';

interface PaymentSystemListState {
  paymentSystemList: PaymentSystemListItem[];
  isPaymentSystemListLoading: boolean;
}

export const usePaymentSystemListStore = defineStore('PaymentSystemListStore', {
  state: (): PaymentSystemListState => ({
    paymentSystemList: [],
    isPaymentSystemListLoading: false,
  }),
  getters: {
    isPaymentSystemListNotEmpty(state: PaymentSystemListState): boolean {
      return state.paymentSystemList.length > 0;
    },
  },
  actions: {
    setPaymentSystemListLoading(isLoading: boolean): void {
      this.isPaymentSystemListLoading = isLoading;
    },
    getPaymentSystemList(
      { filterList, forceUpdate = false }: PaymentSystemListPayload,
    ): Promise<PaymentSystemListItem[]> {
      if (this.paymentSystemList.length && !forceUpdate) {
        return Promise.resolve(this.paymentSystemList);
      }

      this.setPaymentSystemListLoading(true);

      return api.dictionary.getPaymentSystemListRequest.perform({ filterList })
        .then((paymentSystemList: PaymentSystemListItem[]) => {
          this.paymentSystemList = paymentSystemList;

          return paymentSystemList;
        })
        .catch(error => {
          showErrorNotification(error);

          return [];
        })
        .finally(() => {
          this.setPaymentSystemListLoading(false);
        });
    },
  },
});
